export const TICKETLIMITS = [
  { required: true, message: 'requiredItem' },
  { min: 10, message: '10CharsMinimum' },
  { max: 10000, message: '10000CharsMaximum' },
  { whitespace: true, message: 'WHITESPACE' }
]
